import { List } from "@mui/material";
import { useLocation, matchPath } from "react-router-dom";
import SidebarMenuItem from "./item";
import { styled } from "@mui/material/styles";
import { useContext, useState } from "react";
import { Box } from "@mui/material";
import { mergeMenuItems } from "./helpers";
import { SidebarContext } from "../../../../contexts/SidebarContext";
import { LocalStorageContext } from "../../../../contexts/LocalStorageContext";
import { usePropertyReportContext } from "../../../../contexts/PropertyReportContext";

export interface MenuItem {
  link?: string;
  icon?: any;
  badge?: string;
  children?: any[];
  name: string;
}

const SubMenuWrapper = styled(List)(
  ({ theme }) => `
    &.MuiList-root {
      padding: 0;
      font-weight: normal !important;
      margin: 0px !important;
      width: 100% !important;
    }
    .MuiListItem-root {
      // width: 100% !important;
      width: 100% !important;
      padding: 2px 0;
      .MuiButton-root {
        display: flex;
        color: #374151;
        background-color: ${theme.sidebar.menuItemBg};
        width: 100% !important;
        justify-content: flex-start;
        // font-size: ${theme.typography.pxToRem(20)};
        //  font-size: 20px;
        // font-size: clamp(14px, 1.3vw, 20px);
        font-size: calc(5px + 0.5vw);
        // padding: ${theme.spacing(1)} ${theme.spacing(3.25)};
        font-weight: 500;
        font-family: Inter;
        line-height: 24px; 
        padding-left: 12px !important;  
        padding-top: 4px !important;   
        padding-bottom: 4px !important;     
         
 
        position: relative;

        .MuiBadge-root {
          position: absolute;
          // right: ${theme.spacing(4)};
          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(9)};
            font-weight: bold;
            text-transform: uppercase;
            color: rgba(37, 53, 61, 0.9);
            
          }
        }    

        .MuiButton-startIcon {
          font-size: ${theme.typography.pxToRem(26)};
          margin-right: ${theme.spacing(1.5)};
          color: ${theme.sidebar.menuItemIconColor};
          display: none;
        }          
        .MuiButton-endIcon {
          margin-left: auto;
          font-size: ${theme.typography.pxToRem(22)};
          display: none;
        }

        &.Mui-active {
          color: #374151;
          background-color: ${theme.sidebar.menuItemBgActive};
          border-radius: 6px;

          // &:before {
          //   content: '';
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   bottom: 0;
          //   width: 16px;
          //   // background: #EF3340;
          //   background: #99cc0cff;
          //   border-radius: 0 4px 4px 0;
          // }

          // &:after {
          //   content: '';
          //   position: absolute;
          //   right: 0;
          //   top: 0;
          //   bottom: 0;
          //   width: 4px;
          //   // background:rgba(239, 51, 64, 0.20);
          //   background: #43463B;
          // }
        }

        &:hover {
          background-color: ${theme.sidebar.menuItemBgActive};
          color: #374151;
          border-radius: 6px;
        }
      }
    }

    .MuiCollapse-root {
      .MuiList-root {
        padding: ${theme.spacing(1, 0)};
        border-bottom: 1px solid var(--zs-menuSeparation);
      }
    }
  `,
);

interface GroupHeadingProps {
  isFirst?: boolean;
}

const GroupHeading = styled("h4")<GroupHeadingProps>(
  ({ theme, isFirst }) => `
  text-transform: capitalize;
  color: #6B7280;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin-left: 12px;
  // padding: 0px 26px 4px 0px;
  // margin: ${isFirst ? "8px" : "16px"} 0 0;
`,
);

const renderSidebarMenuItems = ({
  items,
  path,
  openMenu,
  setOpenMenu,
  userData,
  onItemClick,
}: {
  items: any;
  path: string;
  openMenu: string[];
  setOpenMenu: Function;
  userData: any;
  onItemClick: (reportId: string, isDocReport: boolean) => void;
}): JSX.Element => (
  <SubMenuWrapper>
    {items?.reduce(
      (ev: any, item: any) =>
        reduceChildRoutes({
          ev,
          item,
          path,
          openMenu,
          setOpenMenu,
          userData,
          onItemClick,
        }),
      [],
    )}
  </SubMenuWrapper>
);

const reduceChildRoutes = ({
  ev,
  path,
  item,
  openMenu,
  setOpenMenu,
  userData,
  onItemClick,
}: {
  ev: JSX.Element[];
  path: string;
  item: MenuItem;
  openMenu: string[];
  setOpenMenu: Function;
  userData: any;
  onItemClick: (reportId: string, isDocReport: boolean) => void;
}): JSX.Element[] => {
  if (item.name) {
    const key = item.name;
    const exactMatch = item.link
      ? !!matchPath({ path: item.link, end: false }, path)
      : false;

    const params = item.link?.startsWith("property-report/")
      ? item.link.replace("property-report/", "").split("/")
      : [];

    const pId = params[0] || null;
    const reportId = params[1] || null;
    const isDocReport = params[2] === "true";

    const clickHandler = reportId
      ? () => onItemClick(reportId!, isDocReport)
      : undefined;

    if (item.children) {
      const partialMatch = item.link
        ? !!matchPath({ path: item.link, end: false }, path)
        : false;

      if (
        item.name === "Report" &&
        userData.userType === "Customer" &&
        !userData?.enableReporting
      ) {
        return ev;
      }

      ev.push(
        <SidebarMenuItem
          key={key}
          active={partialMatch}
          open={partialMatch}
          name={item.name}
          icon={item.icon}
          link={item.link}
          badge={item.badge}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          menus={item}
          onItemClick={clickHandler}
        >
          {renderSidebarMenuItems({
            path,
            items: item.children,
            openMenu,
            setOpenMenu,
            userData,
            onItemClick,
          })}
        </SidebarMenuItem>,
      );
    } else {
      ev.push(
        <SidebarMenuItem
          key={key}
          active={exactMatch}
          name={item.name}
          link={item.link}
          badge={item.badge}
          icon={item.icon}
          openMenu={openMenu}
          setOpenMenu={setOpenMenu}
          menus={item}
          onItemClick={clickHandler}
        />,
      );
    }
  }
  return ev;
};

function SidebarMenu() {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<any>([]);
  const { routes } = useContext(SidebarContext);
  const { userData } = useContext(LocalStorageContext);
  const { reports, propertyId, isDocReport, setPropertyReports } =
    usePropertyReportContext();

  const benchmarkReportsFromApi = reports.filter((r: any) => r.isBenchmark);
  const reportsWithHeading = reports.filter(
    (r: any) => r.heading && !r.isBenchmark,
  );
  const reportsWithoutHeading = reports.filter(
    (r: any) => !r.heading && !r.isBenchmark,
  );
  const reportRoutes = propertyId
    ? [
        ...(reportsWithoutHeading.length
          ? [
              {
                name: "REPORTS",
                items: reportsWithoutHeading.map((report: any) => ({
                  name: report.reportSource?.source || "",
                  link:
                    report.routePath ||
                    `property-report/${propertyId}/${report.id}`,
                })),
              },
            ]
          : []),
        // {
        //   name: reportSources.docReports.heading,
        //   items: reportSources.docReports.sources.map((source: any) => ({
        //     name: source.name,
        //     link: `benchmarking-report/${propertyId}/${source.key}`,
        //   })),
        // },
        ...(reportsWithHeading.length
          ? [
              {
                name: reportsWithHeading[0].heading,
                items: reportsWithHeading.map((report: any) => ({
                  name: report.reportSource?.source || "",
                  link:
                    report.routePath ||
                    `property-report/${propertyId}/${report.id}`,
                })),
              },
            ]
          : []),

        ...(benchmarkReportsFromApi.length
          ? [
              {
                name: "BENCHMARKING",
                items: benchmarkReportsFromApi.map((report: any) => ({
                  name: report.reportSource?.source || "",
                  link: report.routePath,
                })),
              },
            ]
          : []),
      ]
    : [];

  const finalMenu = [...reportRoutes];

  const onItemClick = (reportId: string, isDocReport: boolean) => {
    // const report = isDocReport
    //   ? reports.find((r) => r.reportSourceId === reportId)
    //   : reports.find((r) => r.id === reportId);
    const report = reports.find((r) => r.id === reportId);
    if (report && propertyId) {
      setPropertyReports(propertyId, reportId, reports, isDocReport);
    }
  };

  return (
    <>
      {finalMenu.map((menuItem: any, index: number) => (
        <Box key={index}>
          <>
            {index !== 0 && (
              <Box
                sx={{ borderBottom: "1px solid #C9C9C9", my: 1 }}
              />
            )} 
            <GroupHeading isFirst={index === 0}>{menuItem.name}</GroupHeading>
          </>

          {renderSidebarMenuItems({
            items: menuItem.items,
            path: location.pathname,
            openMenu,
            setOpenMenu,
            userData,
            onItemClick,
          })}
        </Box>
      ))}
    </>
  );
}

export default SidebarMenu;
